import styled from '@emotion/styled'

export const ToggleWrapper = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
`

export const HiddenCheckbox = styled.input`
  display: none;
`

export const Slider = styled.span<{ checked: boolean }>`
  width: 40px;
  height: 20px;
  background: ${({ checked }) => (checked ? '#4CAF50' : '#ccc')};
  border-radius: 20px;
  position: relative;
  transition: background 0.3s ease-in-out;

  &::before {
    content: '';
    position: absolute;
    top: 2px;
    left: ${({ checked }) => (checked ? '22px' : '2px')};
    width: 16px;
    height: 16px;
    background: white;
    border-radius: 50%;
    transition: left 0.3s ease-in-out;
  }
`
